import React from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import WhySellersAnonymous from '../components/WhySellersAnonymous';
import WhatThisIs from '../components/WhatThisIs';
import WhyThisMatters from '../components/WhyThisMatters';
import Meetings from '../components/Meetings';
import IsThisYou from '../components/IsThisYou';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navigation />
      <main>
        <Hero />
        <WhySellersAnonymous />
        <WhatThisIs />
        <WhyThisMatters />
        <Meetings />
        <IsThisYou />
      </main>
      <Footer />
    </div>
  );
};

export default Home;